import React from 'react';
import { Button, Modal, ModalBody } from 'reactstrap';
import i18n from '../../i18next';

const CommonModal = ({ isOpen, onToggle, useCase, children }) => {

    return (
        <Modal size="md" isOpen={isOpen} toggle={() => onToggle(useCase)} className={useCase}>
            <ModalBody>
                {children}
                <div sm={3} style={{ display: 'flex', justifyContent: 'flex-end' }}>
                    <Button outline color="primary" onClick={() => onToggle(useCase)}>{i18n.t('common:buttons.close')}</Button>
                </div>
            </ModalBody>
        </Modal>
    );
}

export default CommonModal;


// WEBPACK FOOTER //
// ./src/components/common/CommonModal.js